var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordBruteForceAttack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5540_88352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 26H27V24C27 21.24 24.76 19 22 19C19.24 19 17 21.24 17 24V26H16C14.9 26 14 26.9 14 28V38C14 39.1 14.9 40 16 40H28C29.1 40 30 39.1 30 38V28C30 26.9 29.1 26 28 26ZM18.9 24C18.9 22.29 20.29 20.9 22 20.9C23.71 20.9 25.1 22.29 25.1 24V26H18.9V24Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4929 17.1446L30.4892 17.1482L31.1348 17.7938H32.1222C32.5247 17.7938 32.912 17.9532 33.193 18.2419L36.7778 21.8267C37.0741 22.1229 37.0741 22.6013 36.7778 22.8976L35.1677 24.5077C34.8715 24.8039 34.393 24.8039 34.0968 24.5077L30.512 20.9229C30.2234 20.6343 30.0639 20.2545 30.0639 19.852V18.8722L26.1525 14.9608L25.8867 15.2267C25.5905 15.5229 25.112 15.5229 24.8158 15.2267L24.2766 14.6874L22.6665 16.2976C21.7778 15.4089 21.7778 13.9659 22.6665 13.0773L24.8158 10.9279C25.112 10.6317 25.5905 10.6317 25.8867 10.9279L26.426 11.4672V9.53806C26.426 9.06717 27.0032 8.81654 27.3449 9.15831L29.2741 11.0874C29.6158 11.4292 29.3652 12.0064 28.8943 12.0064H26.9652L27.5044 12.5457C27.8006 12.8419 27.8006 13.3203 27.5044 13.6165L27.2386 13.8824L27.7236 14.3674L30.4929 17.1446Z",
    fill: "#141414"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5540_88352"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 31,
    fill: "white",
    transform: "translate(14 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordBruteForceAttack);
export default __webpack_public_path__ + "static/media/password_brute_force_attack.286dda1b1ee5bbab1b24cd613c952c31.svg";
export { ForwardRef as ReactComponent };